import { injectIntl } from 'react-intl';
import LanguageSelect from './LanguageSelect';

export default injectIntl(LanguageSelect);
